<template>
    <div>
        <button class="btn btn-outline-danger btn-sm" @click.prevent="removeFollower">{{ __('group.form.buttons.remove') }}</button>
    </div>
</template>

<script>
    export default {
        props: ['data', 'member', 'section'],
        name: "ManageFollowers",
        data() {
            return {
                module: this.data,
                service: this.section,
                user: this.member,
                isAdmin: 'false',
                member_successfully_removed_message: this.__('globals.member_successfully_removed')
            }
        },
        methods: {
            removeFollower(){
                let removeMessage = this.__('group.remove_user_paragraph') + ' ' + this.member.first_name +' '+this.member.last_name +'?';
                if (this.isAdmin === true)
                {
                    removeMessage = this.member.first_name +' '+this.member.last_name + this.__('group.remove_user_message');
                }

                if (confirm(removeMessage))
                {
                    axios.post('/member/'+this.service+'/'+this.module.slug+'/remove/'+this.member.username)
                        .then(response => {
                            if (response.data.status === 200){
                                let flash_data = {
                                    'message': this.member_successfully_removed_message,
                                    'level': 'success'
                                }
                                flash(flash_data);

                                this.$parent.$emit('removed', this.member.id)
                            }
                            else {
                                this.isAdmin = response.data.admin;
                            }

                        });
                }

            },
        },
    }
</script>

<style scoped>

</style>
